module.exports = __webpack_public_path__ + "img/waist_seam.abd527ec.png";